import {FC, useState} from 'react'
import {IProductDraftModel} from '../cors/_models'
import DraftTableRow from './DraftTableRow'
import AlertMessage from '../../common/alert/AlertMsg'
import {useIntl} from 'react-intl'
import NormalMessage from '../../common/NormalMessage'
import '../../../stylesheet/product-list/ProductsTable.css'

interface IProps {
  products: IProductDraftModel[]
  onDeleted: (requestId: number) => void
}
const DraftsTable: FC<IProps> = ({products, onDeleted}) => {
  const {formatMessage} = useIntl()
  const [alert, setAlert] = useState({
    message: '',
    title: '',
    status: false,
  })

  return (
    <>
      {/* begin::Table container */}
      {products.length > 0 ? (
        <table className='table align-middle gs-0 gy-5'>
          <thead>
          <tr>
            <th className='fw-bold p-0'>{formatMessage({id: 'prod_name'})}</th>
            <th className='fw-bold p-0'>{formatMessage({id: 'barcode'})}</th>
            <th className='fw-bold p-0'>{formatMessage({id: 'model_num'})}</th>
            <th className='fw-bold p-0'>{formatMessage({id: 'actions'})}</th>
          </tr>
          </thead>
          <tbody>
          {products &&
            products.map((product) => (
              <DraftTableRow
                key={product.request_id}
                product={product}
                onDeleted={onDeleted}
                showAlert={setAlert}
              />
            ))}
          </tbody>
        </table>
      ) : (
        <NormalMessage msg={formatMessage({id: 'no_data'})} />
      )}
      {alert.message && (
        <AlertMessage
          onClose={() => setAlert({title: '', message: '', status: false})}
          message={alert.message}
          title={alert.title}
          status={alert.status}
        />
      )}
    </>
  );
};

export default DraftsTable;
